import axios from '../../../axios';
import ContractFormType from '../types/ContractRevenueCalculatorType';

const url = '/candidatesearch/api/placement/contract-revenue-calculator';

export const getDefaultRevenueDetails = () => axios.get(`${url}/get-default-revenue-details`);

export const saveDefaultRevenueDetails = (data: ContractFormType) =>
  axios.post(`${url}/add-default-revenue-details`, data);
